import { render, staticRenderFns } from "./AcceptTermsAndConditions.vue?vue&type=template&id=c41ff130&scoped=true&"
import script from "./AcceptTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTermsAndConditions.vue?vue&type=style&index=0&id=c41ff130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41ff130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VIcon,VLayout})
